import { Mutation } from '@varo/graphql-schema-types';
import {
  isGenerateAgreementsForDisbursementError,
  isGenerateAgreementsForDisbursementSuccess,
} from 'features/advance/helpers/AdvanceAgreements/AdvanceAgreements.helpers';
import GenerateAgreementsForDisbursement from 'services/graphql/mutations/Advance/GenerateAgreementsForDisbursement';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

const useAgreementsForDisbursement = () => {
  const [{ data, fetching, error }, execute] = useCancellableMutation<Mutation>(
    GenerateAgreementsForDisbursement,
  );

  const agreementsForDisbursementSuccess =
    data?.generateAgreementsForDisbursement &&
    isGenerateAgreementsForDisbursementSuccess(
      data?.generateAgreementsForDisbursement,
    )
      ? data.generateAgreementsForDisbursement?.agreements
      : undefined;

  const agreementsForDisbursementError =
    data?.generateAgreementsForDisbursement &&
    isGenerateAgreementsForDisbursementError(
      data?.generateAgreementsForDisbursement,
    )
      ? data?.generateAgreementsForDisbursement
      : undefined;

  const isError = Boolean(error || agreementsForDisbursementError);

  return {
    data: agreementsForDisbursementSuccess,
    fetching,
    error: isError,
    execute,
  };
};

export default useAgreementsForDisbursement;
